import { useEffect, useRef, useState } from 'react';
import { useGetSettingsMutation } from '@/queries/communication/settings/settings.mutation';
import { SettingsType } from '@/api/apis/user';

export const useInitializeSettings = (userId?: string, isUserDataInitialized?: boolean) => {
  const { mutateAsync: getSettings } = useGetSettingsMutation();
  const [settingsData, setSettingsData] = useState<SettingsType>();
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (!isUserDataInitialized || !userId || hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    const fetchData = async () => {
      const defaultSettings: SettingsType = {
        push: false,
        sms: false,
        toast: false,
        userId,
      };

      try {
        const data = await getSettings();
        setSettingsData(data);
      } catch {
        setSettingsData(defaultSettings);
      }
    };

    fetchData();
  }, [userId, isUserDataInitialized, getSettings]);

  return settingsData;
};
